import React, { useCallback, useEffect } from 'react'
import styles from './MembershipNumber.module.scss'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { verifyMemberNumber } from '../../../../services/api'

const MembershipNumber = ({
	setSubmitType,
	verifiedStatus,
	memberNumStatus,
	changeMemberNumStatus,
	association,
	memberNumberValue,
	name,
	changeIsModalOpened,
	register,
	isValid,
	errors,
	trigger,
	clearErrors,
	setValue,
}) => {
	const [message, setMessage] = useState('')
	const [isLoading, setIsLoading] = useState(false)
	const navigate = useNavigate()

	const memberNumStatusClassname = styles[memberNumStatus]
	const handleCheckMemNum = async () => {
		setMessage('') // API 결과 메시지 초기화
		changeMemberNumStatus('notTried') // API 상태 초기화 (이것으로 이전 API 메시지 영역 숨김)
		clearErrors('memberNumber') // 유효성 검사 에러도 확실히 지우고 시작합니다.

		const isFieldValid = await trigger('memberNumber')

		if (!isFieldValid) {
			// 유효성 검사 실패시 api 호출 중단
			// setMessage(errors.memberNumber?.message || '유효성 검사에 실패했습니다.')
			return
		}

		if (!name || name.trim() === '') {
			changeMemberNumStatus('failed')
			setMessage('먼저 본인인증을 완료해주세요.')
			return
		}

		setIsLoading(true)

		try {
			const result = await verifyMemberNumber(association, memberNumberValue, name)
			console.log('result:', result)
			if (result.success) {
				changeMemberNumStatus('success')
				setMessage(result.message)
			} else {
				changeMemberNumStatus('failed')
				setMessage(result.message)
			}
		} catch (error) {
			changeMemberNumStatus('failed')
			setMessage('인증중 오류가 발생했습니다')
			console.log('회원번호 인증 오류: ', error)
		} finally {
			setIsLoading(false)
		}
	}

	// useEffect(() => {
	// 	// 'association' 값이 변경될 때 회원번호 인증 상태, 메시지, 그리고 유효성 에러를 모두 초기화합니다.
	// 	changeMemberNumStatus('notTried')
	// 	setMessage('')
	// 	// 🛠️ 'memberNumber' 필드의 유효성 에러를 지웁니다.
	// 	clearErrors('memberNumber')
	// }, [association, clearErrors]) // clearErrors도 의존성 배열에 포함

	// useEffect(() => {
	// 	// 컴포넌트가 처음 마운트될 때는 실행하지 않고, 'association' 값이 변경될 때만 실행
	// 	// memberNumStatus가 이미 'notTried' 상태가 아니라면 초기화
	// 	if (memberNumStatus !== 'notTried') {
	// 		setValue('memberNumber', '')
	// 		changeMemberNumStatus('notTried')
	// 		setMessage('')
	// 	}
	// }, [association, memberNumStatus, changeMemberNumStatus, setValue]) // 의존성 배열에 association을 추가

	const handleNotHaveNum = useCallback(() => {
		clearErrors('memberNumber') // 회원번호 필드 에러 제거
		changeMemberNumStatus('unknown')
	}, [changeMemberNumStatus, clearErrors])

	const handleWaitRegister = useCallback(() => {
		setSubmitType(2)
	}, [changeIsModalOpened])

	const memberNumberFieldRegisterProps = register('memberNumber', {
		required: '회원번호는 필수 입력 항목입니다.',
		pattern: {
			value: /^[0-9]+$/,
			message: '회원번호는 숫자만 입력 가능합니다.',
		},
		minLength: {
			value: association === 'KLPGA' ? 5 : 8,
			message: `회원번호는 최소 ${association === 'KLPGA' ? '5자리' : '8자리'}여야 합니다.`,
		},
		maxLength: {
			value: association === 'KLPGA' ? 5 : 8,
			message: `회원번호는 최대 ${association === 'KLPGA' ? '5자리' : '8자리'}여야 합니다.`,
		},
	})

	const handleInputErrorClear = useCallback(
		(e, fieldName, originalOnChange) => {
			originalOnChange(e) // react-hook-form의 원래 onChange 호출
			clearErrors(fieldName) // 해당 필드의 유효성 검사 에러만 지웁니다.
		},
		[clearErrors],
	)

	useEffect(() => {
		if (memberNumStatus === 'notTried') setMessage('')
		else if (memberNumStatus === 'unknown')
			setMessage('회원번호를 입력하지 않고 가입을 진행합니다.') //
	}, [memberNumStatus])

	const errorMessage = errors.memberNumber?.message
	return (
		<div className={`${styles.flexCol} ${verifiedStatus === 'success' ? '' : styles.none}`}>
			<div className={styles.member}>
				<a>회원번호</a>
				<span className={styles.notMemberNum} onClick={handleNotHaveNum}>
					회원번호가 없어요
				</span>
			</div>
			<div
				className={`${styles.inputWrapper} ${memberNumStatus === 'unknown' ? styles.disabled : ''}`}>
				{association === 'KLPGA' ? (
					<>
						<input
							className={styles.inputWrapperInput}
							type="text"
							placeholder="회원번호 5자리를 입력해주세요"
							maxLength="5"
							disabled={memberNumStatus === 'unknown'}
							{...memberNumberFieldRegisterProps} // ✨ 이제 register가 반환한 객체를 스프레드 ✨
							onChange={(e) =>
								handleInputErrorClear(
									e,
									'memberNumber',
									memberNumberFieldRegisterProps.onChange,
								)
							}></input>
						<button
							type="button"
							onClick={handleCheckMemNum}
							disabled={isLoading || memberNumStatus === 'unknown'}>
							인증하기
						</button>
					</>
				) : (
					<>
						<span className={`${styles.textCenter} ${styles.marginLeft12px}`}>
							TP -{''}
						</span>
						<input
							className={styles.marginLeft12pxInput}
							type="text"
							placeholder="회원번호 8자리를 입력해주세요"
							maxLength="8"
							disabled={memberNumStatus === 'unknown'}
							{...memberNumberFieldRegisterProps} // ✨ register가 반환한 객체를 스프레드 ✨
							onChange={(e) =>
								handleInputErrorClear(
									e,
									'memberNumber',
									memberNumberFieldRegisterProps.onChange,
								)
							}></input>
						<button
							type="button"
							onClick={handleCheckMemNum}
							disabled={isLoading || memberNumStatus === 'unknown'}>
							인증하기
						</button>
					</>
				)}
			</div>
			<div className={errorMessage ? styles.error : styles.none}>{errorMessage}</div>
			<div className={`${memberNumStatusClassname}`}>{message}</div>
			<div
				className={`${styles.afterMemberNumCheckContainer} ${verifiedStatus === 'success' && memberNumStatus !== 'notTried' ? '' : styles.none}`}>
				{memberNumStatus === 'unknown' || memberNumStatus === 'failed' ? (
					<div className={styles.pendingRegisteration}>
						<button
							type="button"
							className={styles.before}
							onClick={() => navigate(-1)}>
							이전
						</button>
						<button
							type="submit"
							className={styles.pending}
							onClick={() => {
								clearErrors('memberNumber') // 회원번호 필드 에러 제거
								setSubmitType(2)
							}}>
							가입 대기하기
						</button>
						<div className={styles.showDetail}>
							입력하신 휴대폰 번호로 가입 승인 현황을 알려드려요.
						</div>
					</div>
				) : (
					<div className={`${styles.buttons}`}>
						<button
							className={styles.successBefore}
							type="button"
							onClick={() => navigate(-1)}>
							이전
						</button>
						<button
							className={styles.next}
							onClick={() => setSubmitType(1)}
							type="submit" // <-- 이 버튼을 클릭하면 상위 <form>이 제출됩니다.
							// 모든 필수 조건 충족 시에만 버튼 활성화
							disabled={
								!isValid || // 1. react-hook-form의 모든 필드 유효성 통과
								verifiedStatus !== 'success' || // 2. 본인인증 성공
								memberNumStatus !== 'success' // 3. 회원번호 인증 성공
							}>
							완료 {/* 또는 "회원가입 완료" */}
						</button>
					</div>
				)}
			</div>
		</div>
	)
}

export default MembershipNumber
